import { z } from 'zod'

const clinicPoliciesSchema = z.object({
  canManage: z.boolean(),
  canViewStaff: z.boolean(),
  canAddStaff: z.boolean(),
  canAddClient: z.boolean(),
})

const agencyPoliciesSchema = z.object({
  canManage: z.boolean(),
  canViewStaff: z.boolean(),
  canAddStaff: z.boolean(),
  canAddClient: z.boolean(),
})

const policiesSchema = z.object({
  canListClinics: z.boolean(),
  canListSessions: z.boolean(),
  clinics: z.record(z.string(), clinicPoliciesSchema),
  agencies: z.record(z.string(), agencyPoliciesSchema),
  canListProgramTemplate: z.boolean(),
  canCreateProgramTemplate: z.boolean(),
})

export const userSchema = z.object({
  uuid: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  shortFullName: z.string(),
  fullNameWithCredentials: z.string(),
  roles: z.array(z.string()),
  lastLogin: z.string().nullable(),
  avatar: z.string().nullable(),
  policies: policiesSchema,
})

export type User = z.infer<typeof userSchema>
